export default "__VITE_ASSET__705100ab__"